import {
  Spin,
  Upload,
  UploadFile,
  UploadProps,
  message as messageToast,
} from "antd";
import { useState } from "react";
import Image from "next/image";
import Global from "@/utils/global";
import imageCompression from 'browser-image-compression';

type CustomUploadProps = {
  width?: number;
  height?: number;
  maxCount?: number;
  onSuccessed?: (picture: string) => void;
};

export const CustomUpload: React.FC<CustomUploadProps> = ({
  maxCount = 5,
  width = 108,
  height = 108,
  onSuccessed,
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [loading, setLoading] = useState(false);

  const handleChange: UploadProps["onChange"] = ({ file, fileList }) => {
    const { status } = file;

    if (status === "uploading") {
      setLoading(true);
    } else if (status === "done") {
      if (file.response.status === 200) {
        const { fileKey, fileName } = file.response.data;
        // setFileList([
        //   ...fileList,
        //   { uid: file.uid, name: fileName, url: Global.imageUrl + fileKey, status: "done" },
        // ]);
        onSuccessed?.(fileKey);
      } else {
        file.status = "error";
        messageToast.error(file.response.message);
      }
      setLoading(false);
    } else if (status === "error") {
      setLoading(false);
    }

    setFileList([...fileList]);
  };

    const compressImage = async (file: File) => {
      const options = {
        maxSizeMB: 10, // 压缩后图片大小（单位：MB）
        // maxWidthOrHeight: 800, // 压缩后图片的最大宽高（单位：像素）
        useWebWorker: true, // 使用 Web Worker 提高性能
        alwaysKeepResolution: true,
        initialQuality: 0.8
      };
  
      try {
        const compressedFile = await imageCompression(file, options);
        return compressedFile; // 返回压缩后的图片文件
      } catch (error) {
        return file; // 如果压缩失败，返回原始文件
      }
    };
  
  // const fileSizeCheck = (file: File) => {
  //   if (file.size / 1024 / 1024 > 10) {
  //     messageToast.error("The file size cannot exceed 10MB!");
  //     return Upload.LIST_IGNORE;
  //   }
  
  //   return true;
  // };

  const uploadButton = (
    <div
      style={{
        width,
        height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <iconpark-icon name="plus" color="#796B64" icon-id="plus" size="2rem" />
      <span className="mt-2 text-xs text-bravve-sub-100">Upload</span>
    </div>
  );

  const beforeUpload = async (file: File) => {
    const compressedFile = await compressImage(file); // 调用压缩函数
    return compressedFile; // 返回压缩后的文件进行上传
  };

  return (
    <>
      <Upload
        listType="picture-card"
        fileList={fileList}
        showUploadList={true}
        onChange={handleChange}
        withCredentials={true}
        action={Global.fileUploadUrlPrefix + "/file/s3/userUploadPreview"}
        // beforeUpload={fileSizeCheck}
        beforeUpload={beforeUpload}
        itemRender={(originNode, file, fileList) => {
          return (
            <div className="relative">
              <div
                style={{
                  position: "absolute",
                  width: 24,
                  height: 24,
                  backgroundColor: "#796B64",
                  zIndex: 999,
                  right: 0,
                }}
                onClick={() => {
                  const index = fileList.findIndex(
                    (item) => item.uid === file.uid,
                  );

                  if (index !== -1) {
                    fileList.splice(index, 1);
                    setFileList([...fileList]);
                  }
                }}
              >
                <div className="flex h-full items-center justify-center">
                  <iconpark-icon size="2rem" color="#fff" name="close-small" icon-id="close-small" />
                </div>
              </div>
              {/* {file.percent === 100 ? (
                <Image
                  src={file.thumbUrl as string}
                  width={width}
                  height={height}
                  sizes="100vw"
                  alt={"upload-image"}
                />
              ) : (
                <Spin  tip="Uploading..."> */}
                  <Image
                    src={file.thumbUrl as string}
                    width={width}
                    height={height}
                    sizes="100vw"
                    alt={"upload-image"}
                  />
                {/* </Spin> */}
              {/* )} */}
            </div>
          );
        }}
      >
        {fileList.length >= maxCount ? null : uploadButton}
      </Upload>
    </>
  );
};
